






































        
  import { AloPanier } from '@/models/alo/AloPanier'
import { timeFromString } from '@/utils/time'
import Vue from 'vue'  
  import Component from 'vue-class-component'  

  @Component({
    name: 'TimePicker', 
    props:{            
      value:{
        type:String,
        default:"00:00"
      },            
      label:{
        type:String,
        default:"Horaire"
      },
      panier:{
        type:Object,
        default:null
      }
    }
  })
  export default class NumberFieldFactor extends Vue {  

    showPicker = false  
    label!:string    
    panier!:AloPanier

    get max() {
      return this.panier && this.panier.timeFin?this.$options.filters!.formatDate(new Date(this.panier.timeFin),"HH:mm",true):undefined
    }

    get min() {      
      return  this.panier?this.$options.filters!.formatDate(new Date(this.minTime),"HH:mm",true):undefined
    }

    get minTime() {
      return Math.max(this.firstAllowedTime,this.panier.timeDebut)
    }

    get firstAllowedTime() {
      return timeFromString(this.$options.filters!.formatDate(new Date(),"HH:mm")) + (this.panier?(this.panier.tempsPreparation * 60000):0)
    }
    
    allowedMinutes(m:number)  {
      return m%15 == 0
    }

  }
